/// <reference path="./index.d.ts" />
import * as React from 'react';
import * as safeLog from '@alife/bc-safe-log';
import { getCardClassName } from './card-type';
import { getText } from '../../utils/i18n';
import { Card } from './card';

/**
 * 判断是否折两行
 *
 * @param {string} desc
 * @returns
 */
function needSplitDesc(desc: string) {
  return desc.indexOf('\n') > -1;
}

interface CouponProps {
  activities: PcCoupon.IActivity[];
  productId: string;
  services: any;
  languageType: string;
  onDidMount?: () => void;
  onListHide?: () => void;
  destoryer?: () => void;
  showList?: boolean;
  i18n: object;
}

interface CouponState {
  xman: any;
  showCoupons: boolean;
  showTip: boolean;
  tipIcon: string;
  tipContent: string;
}

export class Coupon extends React.Component<CouponProps, CouponState> {
  i18nMap: {
    added: string;
    get: string;
  };

  constructor(props) {
    super(props);

    const { i18n } = props;
    this.state = {
      xman: null,
      showCoupons: false,
      showTip: false,
      tipIcon: '',
      tipContent: '',
    };

    this.i18nMap = {
      added: getText(i18n, 'undue_market_action.coupon.added', 'Coupon Added'),
      get: getText(i18n, 'undue_market_action.coupon.get', 'Get Coupon'),
    };
  }

  componentDidMount() {
    document.addEventListener('click', this.hideCoupon);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.hideCoupon);
  }

  getTopCoupon = () => {
    const { activities } = this.props;
    return activities[0];
  };

  getCardStatus = id => {
    if (this.state[id] !== undefined) {
      if (this.state[id] === false) {
        // 已领取
        return {
          status: this.i18nMap.added,
          canClick: false,
        };
      }
      // 可领取
      return {
        status: this.i18nMap.get,
        canClick: true,
      };
    }
    const { activities } = this.props;
    const curCoupon = activities.find(coupon => coupon.spreadId === id);
    if (!curCoupon) {
      return {
        status: this.i18nMap.get,
        canClick: true,
      };
    }
    if (curCoupon.canApplying && curCoupon.stock) {
      // 可领取
      return {
        status: this.i18nMap.get,
        canClick: true,
      };
    }
    if (!curCoupon.canApplying) {
      // 已领取
      return {
        status: this.i18nMap.added,
        canClick: false,
      };
    }
    return {
      status: this.i18nMap.get,
      canClick: true,
    };
  };

  setCardStatusById = (id, canApply) => {
    this.setState({
      ...this.state,
      [id]: canApply,
    });
  };

  handleArrowClick = e => {
    e.nativeEvent.stopImmediatePropagation();
    this.setState({
      ...this.state,
      showCoupons: !this.state.showCoupons,
    });
  };

  handleDrawCoupon = (id, pid) => {
    safeLog.default(
      '/sc.details.getCouponClick',
      'CLK',
      'channel=pc&applyplace=0',
      'GET',
    );
    const {
      services: { Xman },
    } = this.props;
    let { xman } = this.state;
    if (!xman) {
      Xman(gXman => {
        xman = new gXman.Popup({
          members: 'both',
          locale: 'en_US',
        });
        if (xman.isLoggedIn()) {
          this.drawCoupon(id, pid);
        } else {
          xman.show();
          xman.on('LOGIN_SUCCESS', () => {
            this.setState({
              ...this.state,
              showCoupons: true,
            });
            this.drawCoupon(id, pid);
          });
        }
      });
    } else if (xman.isLoggedIn()) {
      this.drawCoupon(id, pid);
    } else {
      xman.show();
      xman.on('LOGIN_SUCCESS', () => {
        this.setState({
          ...this.state,
          showCoupons: true,
        });
        this.drawCoupon(id, pid);
      });
    }
  };

  hideCoupon = () => {
    this.setState({
      ...this.state,
      showCoupons: false,
    });
    if (this.props.onListHide) {
      this.props.onListHide();
    }
    if (this.props.destoryer) {
      this.props.destoryer();
    }
  };

  drawCoupon = (id, pid) => {
    const {
      services: { CouponCardService },
      languageType,
    } = this.props;
    CouponCardService.applyCoupon(id, pid, languageType).then(
      res => {
        // 领取成功
        if (res.code === 200) {
          safeLog.default(
            '/sc.details.getCouponSuccess',
            'CLK',
            'channel=pc&applyplace=0',
            'GET',
          );
          this.setCardStatusById(id, false);
          this.showTip('success', res.message);
          return;
        }
        // 已经领取过了
        if (res.code === 402) {
          this.setCardStatusById(id, false);
          this.showTip('dialog.purchased', res.message);
          return;
        }
        // 优惠券已经领取完了
        if (res.code === 401) {
          this.showTip('dialog.no', res.message);
          return;
        }
        if (res.code === 403) {
          this.showTip('dialog.cannot', res.message);
          return;
        }
        this.showTip('', res.message);
      },
      err => {
        console.error(err);
        this.showTip('？？？？', 'i18n');
      },
    );
  };

  showTip = (icon, content) => {
    this.setState({
      ...this.state,
      showTip: true,
      tipIcon: icon,
      tipContent: content,
    });
    setTimeout(() => {
      this.setState({
        ...this.state,
        showTip: false,
        tipContent: '',
      });
    }, 5000);
  };

  render() {
    const { showCoupons, showTip, tipContent, tipIcon } = this.state;
    const { activities, productId } = this.props;
    const needSplit = needSplitDesc(
      this.getTopCoupon().presentationDescription,
    );
    return (
      <div
        className="module-coupon detail-mainscreen-center-grid"
        style={{
          marginBottom: 12,
        }}
      >
        {!this.props.showList && (
          <div
            className={
              getCardClassName(this.getTopCoupon().rangeType).entryBackground
            }
            onClick={this.handleArrowClick}
          >
            <span className="coupon-entry-price">
              {this.getTopCoupon().presentationTitle}{' '}
            </span>
            {needSplit && (
              <span
                className="coupon-entry-dis"
                title={
                  this.getTopCoupon().presentationDescription.split('\n')[1]
                }
              >
                {this.getTopCoupon().presentationDescription.split('\n')[1]}
              </span>
            )}
            {!needSplit && (
              <span
                className="coupon-entry-dis"
                title={this.getTopCoupon().presentationDescription}
              >
                {this.getTopCoupon().presentationDescription}
              </span>
            )}
            <span className="coupon-entry-action">{this.i18nMap.get}</span>
            {!showCoupons && <i className="ui2-icon ui2-icon-arrow-down" />}
            {showCoupons && <i className="ui2-icon ui2-icon-arrow-up" />}
          </div>
        )}
        {(this.props.showList || (!this.props.showList && showCoupons)) && (
          <div className="coupon-list-container">
            <ul className="coupon-list">
              {activities.map(couponCard => (
                <Card
                  key={couponCard.spreadId}
                  handleDrawCoupon={this.handleDrawCoupon}
                  id={couponCard.spreadId}
                  logo={couponCard.logoUrl}
                  productId={productId}
                  status={this.getCardStatus(couponCard.spreadId).status}
                  canClick={this.getCardStatus(couponCard.spreadId).canClick}
                  {...couponCard}
                />
              ))}
            </ul>
            {(this.props.showList || (!this.props.showList && showCoupons)) &&
              tipIcon !== 'success' && (
                <div className={showTip ? 'coupon-tip' : 'coupon-tip tip-hide'}>
                  <i className="next-icon next-icon-error next-icon-small" />
                  {tipContent}
                </div>
              )}
            {(this.props.showList || (!this.props.showList && showCoupons)) &&
              tipIcon === 'success' && (
                <div className={showTip ? 'coupon-tip' : 'coupon-tip tip-hide'}>
                  <i className="next-icon next-icon-success next-icon-small" />
                  <span className="coupon-tip-content">{tipContent}</span>
                </div>
              )}
          </div>
        )}
      </div>
    );
  }
}
